export const HOME = '/';
export const WILLFORM = '/will-form';
export const WILLDISPLAY = '/will-display'
export const PAGENOTFOUND = '404-page-not-found'
